// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"513":"f4043724","545":"a70636df"}[chunkId] + ".chunk.js";
};